import React from "react";

export default class PreviewNodeWidget extends React.Component {
    /**
     * Node view wrapper for diagram preview; no mouse events
     * @module PreviewNodeWidget
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div
                className={"node"}
                style={{
                    top: this.props.node.y,
                    left: this.props.node.x
                }}
            >
                {this.props.children}
            </div>
        );
    }
}